module.exports = __webpack_public_path__ + "img/skin_dress_flyer_front.3ea3910d.jpg";